export default __webpack_public_path__ + "static/media/fox@2x.1c5a4c7d.png";